import { Logo } from "../../components/ui/Logo";

const ONBOARDING = "https://consent.sugalarm.com/onboarding.html";
const HOME = "https://www.sugalarm.com";

/**
 * Cycle 281: shown instead of the login screen when a plain web browser hits
 * the signed-out app during Early Access (see `webAccessAllowed`). The native
 * app + any kiosk never see this — they pass the gate and get the normal
 * login / pairing flow.
 */
export function WebGate() {
  return (
    <div
      style={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px 20px",
        background:
          "radial-gradient(900px 520px at 78% 6%, rgba(59,157,255,0.18), transparent 60%)," +
          "radial-gradient(760px 520px at 10% 20%, rgba(255,81,87,0.10), transparent 58%)," +
          "linear-gradient(180deg, #08111f, #070f1c)",
        color: "#eef4ff",
        fontFamily:
          '-apple-system, BlinkMacSystemFont, "Segoe UI", Inter, Roboto, sans-serif',
        textAlign: "center",
      }}
    >
      <div style={{ maxWidth: 440, width: "100%" }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 20 }}>
          <Logo size={72} />
        </div>
        <h1
          style={{
            fontSize: "clamp(26px, 6vw, 34px)",
            lineHeight: 1.1,
            letterSpacing: "-0.02em",
            margin: "0 0 14px",
            fontWeight: 800,
          }}
        >
          Sugar Alarm on the web is coming soon
        </h1>
        <p style={{ color: "#a9bbd9", fontSize: 16, margin: "0 0 26px", lineHeight: 1.6 }}>
          Web access is part of an upcoming subscription. During Early Access,
          use the free <strong style={{ color: "#eef4ff" }}>iOS or Android app</strong>{" "}
          — or a Sugar Alarm <strong style={{ color: "#eef4ff" }}>kiosk</strong> — to sign in and
          watch a loved one's glucose.
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <a
            href={ONBOARDING}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8,
              fontWeight: 700,
              fontSize: 15,
              padding: "14px 22px",
              borderRadius: 999,
              textDecoration: "none",
              color: "#fff",
              background: "linear-gradient(180deg, #3b9dff, #1e6fe0)",
              boxShadow: "0 10px 30px -8px rgba(59,157,255,0.6)",
            }}
          >
            Request early access →
          </a>
          <a
            href={HOME}
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: 700,
              fontSize: 15,
              padding: "13px 22px",
              borderRadius: 999,
              textDecoration: "none",
              color: "#eef4ff",
              border: "1px solid #2c4272",
            }}
          >
            Learn more
          </a>
        </div>
        <p style={{ color: "#6f83a6", fontSize: 13, marginTop: 26 }}>
          Already using the app or a kiosk? Open Sugar Alarm there — this only
          affects web browsers.
        </p>
      </div>
    </div>
  );
}
